import { connect } from 'react-redux';
import EditRouteModal from '../../components/Dispatch/EditRouteModal';
import { saveRouteEdits, fetchAllRoutes, fetchSelectedRouteDispatchId } from '../../actions/dispatch_actions';

function mapStateToProps(state) {
  return {
    // savingNewRoute: state.dispatch.savingNewRoute,
    // saveNewRouteSuccess: state.dispatch.saveNewRouteSuccess,
    // saveNewRouteError: state.dispatch.saveNewRouteError,
    savingRouteEdits: state.dispatch.savingRouteEdits,
    saveRouteEditsSuccessful: state.dispatch.saveRouteEditedSuccessful,
    allRoutesLEES: state.dispatch.allRoutesLEES,
  };
}

export default connect(mapStateToProps, { saveRouteEdits, fetchAllRoutes, fetchSelectedRouteDispatchId })(EditRouteModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/EditRouteModal.jsx